export const companyName = "Quattro Software";

export const primaryColor = "#004b95";
